import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getPlan,
  getAddons,
  openModal,
  closeModal,
  getCustomerByEmail,
  otpGeneration,
  verifyOtp,
  resetPlan,
  setEmail,
  setSubscriptionPlan,
  getPlanDetails
} from '../../../store/actions';

import Loader from '../../../assets/components/loader';
import CheckIcon from '../../../assets/svg/checkIcon';

import PlanSkeleton from './planSkeleton';

import Alert from '../../../utils/components/Alerts';
import { setCustomer } from '../../../utils/helpers';

import { useParams, useNavigate } from 'react-router-dom';
import { CurrencyCodes } from '../../../shared/CurrencyCodes';
import { BillingCycles } from '../../../shared/BillingCycles';

import { useScreenSize } from '../../../hooks/ScreenSize';

import Swal from "sweetalert2";

import LoginModal from './loginModal';

const currencyCodes = CurrencyCodes
const billingCyclies = BillingCycles

const Plan = (props) => {

  const dispatch = useDispatch();
  const plansInfo = useSelector((state) => state.plan);
  const params = useParams();
  const navigate = useNavigate();

  const [plan, setPlan] = useState()
  const [subscriptionItems, setSubscriptionItems] = useState({});

  const screenSize = useScreenSize();

  const [currency, setCurrency] = useState("USD")
  const [period, setPeriod] = useState("Monthly")

  const [user, setUser] = useState({
    email: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    otp: {
      value: "",
      focused: false,
      required: true,
      error: ""
    }
  })

  useEffect(() => {
    let subscriptionPlan = []
    subscriptionPlan.push({
      itemPriceId: plansInfo.plan.id,
      name: plansInfo.plan.externalName,
      unitPrice: plansInfo.plan.price,
      quantity: 1,
      itemType: plansInfo.plan.itemType
    })
    if (plansInfo && plansInfo.addons && plansInfo.addons.length) {
      plansInfo.addons.map((it, i) => {
        if (subscriptionItems[`${it.id}`] > 0) {
          subscriptionPlan.push({
            itemPriceId: it.id,
            name: it.externalName,
            quantity: subscriptionItems[`${it.id}`],
            unitPrice: it.price
          })
        }
      })
    }
    if (plansInfo.redirect === true && plansInfo.target === "/signUp"){
      setCustomer("")
      dispatch(setSubscriptionPlan(subscriptionPlan))
      dispatch(setEmail(user.email.value))
      dispatch(resetPlan())
      dispatch(closeModal())
      navigate(plansInfo.target)
    } else if (plansInfo.redirect === true && plansInfo.target === "/payment"){
      setCustomer(plansInfo.customerId)
      dispatch(setSubscriptionPlan(subscriptionPlan))
      dispatch(resetPlan())
      dispatch(closeModal())
      navigate(plansInfo.target)
    }
  }, [plansInfo.redirect])

  useEffect(() => {
    if (params && params.planId){
      let plan = params.planId[0].toUpperCase() + params.planId.slice(1).toLowerCase()
      setPlan(plan)
    }
  }, [])

  useEffect(()=>{
    if (plan && !plansInfo.planObtanied && !plansInfo.plan.hasOwnProperty("id")){
      let data = {
        currency: currency,
        period: period.toLowerCase().replace("ly", "")
      }
      dispatch(getPlanDetails(plan));
      dispatch(getAddons(data));
      dispatch(getPlan(`${plan}-${currency}-${period}`));
    }
  }, [plan, plansInfo.planObtanied])

  useEffect(()=>{
    if (plansInfo.planObtanied && plansInfo.addonsObtained) {
      let data = {
        currency: currency,
        period: period.toLowerCase().replace("ly", "")
      }
      dispatch(getPlan(`${plan}-${currency}-${period}`));
      dispatch(getAddons(data));
    }
  }, [currency, period])

  useEffect(() => {
    if (plansInfo && plansInfo.addons && plansInfo.addons.length > 0){
      let items = {}
      if (Object.keys(subscriptionItems).length === 0) {
        plansInfo.addons.map((it) => {
          items[it.id] = 0
        })
      }
    }
  }, [plansInfo.addons])

  useEffect(() => {
    if (plan && !plansInfo.planDetailsObtained){
      dispatch(getPlanDetails(plan));
    }
  }, [plansInfo.planDetailsObtained])

  useEffect(() => {
    if (plansInfo.modalOn === false){
      setUser({
        email: {
          value: "",
          focused: false,
          required: true,
          error: ""
        },
        otp: {
          value: "",
          focused: false,
          required: true,
          error: ""
        }
      })
    }
  }, [plansInfo.modalOn])

  useEffect(() => {
    if (plansInfo.sendOtp){
      dispatch(otpGeneration({ email: plansInfo.email, name: plansInfo.customerName }))
    }
  }, [plansInfo.sendOtp])

  function selectInputChange(ev){
    if(ev.target.name === "currency"){
      setCurrency(ev.target.value)
    }else if(ev.target.name === "period"){
      setPeriod(ev.target.value)
    }
  }

  function changeAddonsValue(ev){
    let value = parseInt(ev.target.value)
    if(value < 0){
      value = value*-1
    }else if(value > 999){
      value = 999
    }
    setSubscriptionItems({...subscriptionItems,
      [ev.target.name] : parseInt(value)
    })
  }

  function totalCalculation () {
    let total = 0
    let planTotal = 0
    let addonsTotal = 0
    if (plansInfo && plansInfo.plan && plansInfo.plan.price){
      planTotal = plansInfo.plan.price
    }
    if (plansInfo && plansInfo.addons && plansInfo.addons.length){
      plansInfo.addons.map((it, i) => {
        if (subscriptionItems[`${it.id}`] > 0) {
          addonsTotal += (subscriptionItems[`${it.id}`] * it.price)
        }
      })
    }
    total = planTotal + addonsTotal
    return total/100
  }

  function saveSubscriptionPlan(){
    dispatch(openModal())
  }

  const handleInputChange = (ev) => {
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        value: ev.target.value,
        focused: true,
        error: prevUser[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const handleOnfocus = (ev) => {
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        focused: true,
        error: prevUser[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const validate = (name, value) => {
    switch (name) {
      case ("email"):
        if (value.length === 0) {
          return "Email is required"
        } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) === false) {
          return "Email is not valid"
        } else {
          return ""
        }
      case ("otp"):
        if (value.length === 0) {
          return "One Time Password (OTP) is required"
        } else {
          return ""
        }
      default:
        return ""
    }
  }

  function checkUser(ev){
    ev.preventDefault();
    const data = {
      email: user.email.value,
      showNotification : false
    }
    dispatch(getCustomerByEmail(data));
  }

  function newOtp(ev){
    ev.preventDefault();
    dispatch(otpGeneration({ email: plansInfo.email, name: plansInfo.customerName }))
  }

  function checkOtp(ev){
    ev.preventDefault();
    let data = {
      user_otp: user.otp.value,
      key: plansInfo.otpKey,
      email: plansInfo.email
    }
    dispatch(verifyOtp(data));
  }

  useEffect(()=>{
    if (plansInfo.loadedFirstTime && !plansInfo.loading && screenSize > 900) {
      setTimeout(()=>{
        const leftside = document.querySelectorAll('.plan--info')[0];
        const rigthSide = document.querySelectorAll('.plan--addons')[0];
        const maxHeigth = Math.max(leftside.getBoundingClientRect().height, rigthSide.getBoundingClientRect().height) - 50
        leftside.style.height = `${maxHeigth}px`;
        rigthSide.style.height = `${maxHeigth}px`;
      }, 200)
    }
  }, [plansInfo.loadedFirstTime, plansInfo.loading, screenSize])

  useEffect(() => {
    if (plansInfo.planNotFound === true){
      Swal.fire({
        icon: 'error',
        text: `The plan you are looking for does not exist`,
        confirmButtonText: "Accept",
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false,
        didOpen() {
          let confirmButtons = document.getElementsByClassName("swal2-confirm")[0]
          confirmButtons.style.backgroundColor = "#611C35";
          confirmButtons.style.boxShadow = "none";
          confirmButtons.style.color = "#ffffff";
          confirmButtons.style.border = "#611C35";
        }
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(resetPlan());
          setTimeout(()=>{
            window.location.href="https://www.marquet.cloud/pricing";
          }, 300)
        }
      })
    }
  }, [plansInfo.planNotFound])

  if (!plansInfo.loadedFirstTime || !plansInfo.plan.hasOwnProperty("id")){
    return (
      <PlanSkeleton />
    )
  }

  window.addEventListener('popstate', () => { dispatch(closeModal()) }); // Run the effect only once after the initial render

  return (
    <>
      <div className="plan--selected">
        <div className="plan--side">
          <div className="plan--info">
            <div className="plan--img" style={plansInfo && plansInfo.planDetails && plansInfo.planDetails.img ? {display:"flex"}:{display:"none"}}>
              <img src={plansInfo && plansInfo.planDetails && plansInfo.planDetails.img ? plansInfo.planDetails.img : ""} />
            </div>
            <div className="main--features">
              <h2>
                {plansInfo && plansInfo.plan && plansInfo.plan.externalName ? plansInfo.plan.externalName : ""}
              </h2>
              <div>
                {plansInfo && plansInfo.planDetails && plansInfo.planDetails.basicFeatures &&
                  plansInfo.planDetails.basicFeatures.map((it, i) => (
                    <p key={i}>{it}</p>
                  ))
                }
              </div>
            </div>
            <div className="plan--currency">
              <label>Currency</label>
              <div>
                {/*<select name="currency" value={currency} onChange={ev => selectInputChange(ev)}>
                  {currencyCodes && currencyCodes.length > 0 && currencyCodes.map((it, i) => (
                    <option key={i} value={it.code}>{it.name}</option>
                  ))}
                </select>*/}
                <section className='currency'>US Dollar</section>
                {plansInfo.loading === true ?
                  <div>
                    <Loader size="sm" />
                  </div> :
                  <input
                    type="text"
                    value={plansInfo && plansInfo.plan && plansInfo.plan.price ? (plansInfo.plan.price/100).toLocaleString('en-US', { style: 'currency', currency: plansInfo.plan.currencyCode }) : "$0"}
                    disabled />
                }
              </div>
            </div>
            <div className="plan--cycle">
              <label>Billing Cycle</label>
              <select name="period" value={period} onChange={ev => selectInputChange(ev)}>
                {billingCyclies && billingCyclies.length > 0 && billingCyclies.map((it, i) => (
                  <option key={i} value={it.period}>{it.period}</option>
                ))}
              </select>
            </div>
            <div className="change--plan">
              <a className="custom--links" href="https://www.marquet.cloud/pricing">Select a different package</a>
            </div>
          </div>
          <div className="plan--features">
            {/*plansInfo && plansInfo.planDetails && plansInfo.planDetails.allFeatures &&
              plansInfo.planDetails.allFeatures.map((it, i) => (
                <div key={i}>
                  <CheckIcon/> <div>{it}</div>
                </div>
              ))
            */}
          </div>
          <div className='plan-feature-per-category'>
            {plansInfo && plansInfo.planDetails && plansInfo.planDetails.features && Array.isArray(plansInfo.planDetails.features) &&
              plansInfo.planDetails.features.map((it, i) => (
                <div key={i}>
                  <h2 className='category-label'>{it.featureName}</h2>
                  <ul>
                    {it.description && Array.isArray(it.description) && it.description.map( (item, ii) => (
                      <li key={ii}><CheckIcon color='rgb(42, 47, 51)'/> {item}</li>
                    ))}
                  </ul>
                </div>
              ))
            }
          </div>
        </div>
        <div className="addons--side">
          <div className="plan--addons">
            <h2>
              Add-ons Available
            </h2>
            <div className="addons--container">
              {(!plansInfo.addons || plansInfo.addons.length === 0 || plansInfo.planDetails.hasAddons === false) && <Alert type={"marquet"}>
                <p>No addons Available</p>
              </Alert>
              }
              {plansInfo && plansInfo.addons && plansInfo.addons.length > 0 && plansInfo.planDetails.hasAddons === true && plansInfo.addons.map((it, i) => (
                <div key={i}>
                  <div><CheckIcon /></div>
                  <div>
                    <div className="addon--name">{it.externalName}</div>
                    <div className="addon--feature">
                      {plansInfo.loading === true ?
                        <>
                          <Loader size="xs" />
                          {`per ${it.metadata && it.metadata.unit ? it.metadata.unit : ""}/${it.metadata && it.metadata.periodUnit ? it.metadata.periodUnit : ""}`}
                        </> :
                        <>
                          <span>{`${(it.price / 100).toLocaleString('en-US', { style: 'currency', currency: it.currencyCode })}`}</span>
                          {`per ${it.metadata && it.metadata.unit ? it.metadata.unit : ""}/${it.metadata && it.metadata.periodUnit ? it.metadata.periodUnit : ""}`}
                        </>
                      }
                    </div>
                  </div>
                  <div className="addon--quantity">
                    <label>Qty</label>
                    <input
                      type="number"
                      name={it.id}
                      value={subscriptionItems && subscriptionItems[`${it.id}`] ? subscriptionItems[`${it.id}`] : 0}
                      onChange={ev => changeAddonsValue(ev)}
                      min={0}
                      max={999}
                      step={1} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="subtotal">
            {plansInfo && plansInfo.addons && plansInfo.addons.length > 0 ?
              <div className="addons--subtotal">
                <h3>My addons</h3>
                {plansInfo && plansInfo.addons && plansInfo.addons.length > 0 && plansInfo.addons.map((it, i) => {
                  if (subscriptionItems[`${it.id}`] > 0) {
                    return (
                      <div key={i}>
                        <div>
                          {`${subscriptionItems[`${it.id}`]} ${it.externalName}`}
                        </div>
                        <div>
                          {`${((subscriptionItems[`${it.id}`] * it.price) / 100).toLocaleString('en-US', { style: 'currency', currency: it.currencyCode })}`}
                        </div>
                      </div>
                    )
                  }
                })}
              </div> : <div className="addons--subtotal"s></div>
            }
            <div className="subtotal--price">
              <h3>Sub Total</h3>
              <div>
                {totalCalculation().toLocaleString('en-US', { style: 'currency', currency: plansInfo.plan.currencyCode })}
              </div>
            </div>
            <div className="taxes">
              <p>
                Taxes will be applied at check-out according to your location.
              </p>
            </div>
            <div className="total--price">
              <h2>Total</h2>
              <div>
                {totalCalculation().toLocaleString('en-US', { style: 'currency', currency: plansInfo.plan.currencyCode })}
              </div>
            </div>
          </div>
        </div>
        <div className="submit--region">
          <button
            onClick={ev => saveSubscriptionPlan(ev)}
            className="custom--button custom--button--marquet">
            Save and Continue
            {plansInfo.loading && <Loader size="xs" />}
          </button>
        </div>
      </div>
      {(plansInfo.modalOn &&
        <LoginModal
          modalTitle={plansInfo.modalStep === 1 ? "ENTER YOUR EMAIL TO PROCEED" : "VERIFICATION"}
          changeModalState={ev => {dispatch(closeModal())}}
          handleInputChange={ev => handleInputChange(ev)}
          handleOnfocus={ev => handleOnfocus(ev)}
          user={user}
        onSave={plansInfo.modalStep === 1 ? ev => checkUser(ev) : ev => checkOtp(ev)}
          loading={plansInfo.modalLogin}
          checkOTP={plansInfo.modalStep === 2 ? true : false}
          requestOtpFunction={ev => newOtp(ev)}
          requestOtp={plansInfo.requestOtp}
          />)}
    </>
  )

}

export default Plan;